import { useState } from 'react';
import { updateTicket } from "../lib/ticket.js";
import { NrlkException } from '../model/exception.js';

/**
 * Fournit une fonction `update({ idTicket, titre, description, priorite, dateDebut, dateFin, idType, intervenant })` pour modifier un ticket et expose `{ update, loading, error }`.
 *
 * @returns {{ update: Function, loading: boolean, error: string|null }}
 */
export const useUpdateTicket = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const update = async ({
    idTicket,
    titre,
    description,
    priorite,
    dateDebut,
    dateFin,
    idType,
    intervenant = [],
  }) => {
    setLoading(true);
    setError(null);

    try {
      const updatedTicket = await updateTicket(
        idTicket,
        titre,
        description,
        priorite,
        dateDebut,
        dateFin,
        idType,
        intervenant
      );
      return updatedTicket;
    } catch (err) {
      if (err instanceof NrlkException) {
        setError(err.message);
      } else {
        setError('Une erreur inconnue est survenue');
      }
    } finally {
      setLoading(false);
    }
  };

  return { update, loading, error };
};
